/* eslint-disable react/destructuring-assignment */
import React from "react";
import { useSelector } from "react-redux";
import store from "store";
import { RootState } from "store/ducks";
import { Tooltip as ReactTooltip } from 'react-tooltip';

import {
  BaseField,
} from "pipestyle";

import TicketServices from "services/ticket.service";

import { Row, Column } from "components/Layout/Grid";
import Animated from "components/Animated";
import Validator from 'components/Validator';
import Form from "components/Form";
import { DateExpire } from 'components/Pipefy/DateExpire';
import { Visibility } from 'components/Visibility';

import {
  FieldsCardProps,
  FieldsCurrentPhaseProps
} from "pages/Pipefy/interface";

import imgToolTipRI from 'img/icon-duvida.svg';
import iconOrderLost from 'img/icon-order-lost.svg';
import iconAlert from 'img/question-img.svg';

import {
  PhasesProtocols,
  EnumDisableContext
} from "pages/Pipefy/enum";

interface IProps {
  form: any;
  components: any;
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  moveCard: boolean;
  blockMoveCardAwaitUpdateField: boolean;

  setMoveCard: React.Dispatch<React.SetStateAction<boolean>>;
  setLastChangedField: React.Dispatch<React.SetStateAction<any>>;

  getPhases: Function;
  moveCardTo: Function;
  showField: Function;
  isDisabledInputsCheckListAndRadio: Function;
  isFieldRequired: Function;
  showValueOfValidator: Function;
  requiredInputVigencyDate: Function;
  mustInputBeReadOnly: Function;
  setMoveCardDisable: Function;
  setValueBUSelected: Function;
}

const PhaseForm: React.FC<IProps> = (props) => {
  const { form, components, state, setState, moveCard, blockMoveCardAwaitUpdateField } = props;
  const { setMoveCard, setLastChangedField } = props;
  const { getPhases, moveCardTo, showField, isDisabledInputsCheckListAndRadio, isFieldRequired } = props;
  const { showValueOfValidator, requiredInputVigencyDate } = props;
  const { mustInputBeReadOnly, setMoveCardDisable, setValueBUSelected } = props;

  const user = useSelector((state: RootState) => state.user);
  const card = useSelector((state: RootState) => state.card);

  const _ticketService = new TicketServices();

  function getPastPhases() {
    return getPhases(true);
  }

  function getInputDescriptionById(id: string) {
    return (
      form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === id)?.field
        ?.description || ""
    );
  }

  const setVisibleOrShowExpiredDate = (fields: FieldsCardProps[]) => {
    if (fields && form) {
      const phasesHide = ['devolução', 'reclamação técnica', 'logística', 'logistica'];
      const categoryCardName = fields.find((x: FieldsCardProps) => x.name === "Categoria do Protocolo");

      if (form?.card.done) return false;
      if (form?.card.current_phase.name === 'Novo') return false;

      return categoryCardName ? !phasesHide.includes(categoryCardName.value.toLowerCase()) : false;
    }

    return false;
  };

  const setMinLengthReviewLetter = (item: FieldsCurrentPhaseProps) => {
    if (item.id === "revis_o_do_texto_da_carta_de_corre_o" || item.id === "revis_o_do_texto_da_carta_de_corre_o_1") {
      if (state[item.id] && state[item.id].length > 0) return 15;
    } else return undefined;
  };

  const onSubmit = async (_propsSubmit: any) => {
    if (
      form.card.current_phase.name === PhasesProtocols.DESABILITAR_MOVE_PARA
    ) {
      await _ticketService
        .get(undefined, undefined, undefined, { id: card?.ticketId })
        .then((result: any) => {
          if (result.data) {
            if (result.data[0].ticketDevolution) {
              store.dispatch({
                type: "UPDATE_CARD",
                ticketDevolution: result.data[0].ticketDevolution || null,
              });
            } else {
              setMoveCard((oldCard) => !oldCard);
            }
          } else {
            setMoveCard((oldCard) => !oldCard);
          }
        });
    } else {
      setMoveCard((oldCard) => !oldCard);
    }
  };

  function hasCustomForm(phaseName: string | null = null) {
    if (phaseName == null) {
      return (form.card.current_phase.name === PhasesProtocols.COMPLEMENTO_EXTRAVIO || form.card.current_phase.name === PhasesProtocols.REGISTRO_EVENTOS_ADVERSOS)
    } else {
      return (form.card.current_phase.name === phaseName)
    }
  };

  return (
    <Column
      className="flex-1 pp-card-right"
      style={{
        borderRadius: 5,
        padding: "10px 0 10px 0",
      }}
    >
      <Column
        className="relative flex-1 bg-white"
        style={{
          overflow: "hidden",
          borderRadius: 5,
          marginLeft: -2,
          boxShadow: "0 2px 14px 0 rgba(97,123,160,.4)",
        }}
      >
        <Form
          id="pipefy_form"
          onValidate={(data: any) => onSubmit(data)}
          className="overflow-y-auto pp-scroll p-4"
        >
          <Column style={{ marginBottom: 71 }}>
            <strong className="pp-title-description">
              Fase atual
            </strong>
            <h2 className="font-bold mt-1 mb-3" style={{ fontSize: 22 }}>
              {form.card.current_phase.name}
            </h2>

            <Visibility visible={hasCustomForm(PhasesProtocols.COMPLEMENTO_EXTRAVIO)}>
              <>
                <img
                  width={60}
                  src={iconAlert}
                  alt=""
                  style={{ marginTop: 120, marginBottom: 20, alignSelf: 'center' }}
                />
                <span style={{ textAlign: 'center', lineHeight: 1.5 }}>
                  Para seguir com o atendimento deste protocolo é necessário complementar o processo com os dados dos itens extraviados.
                </span>
                <span style={{ textAlign: 'center', paddingTop: 4 }}>
                  Para isso, utilize o ícone <img
                    width={18}
                    src={iconOrderLost}
                    alt=""
                    style={{ marginLeft: 5, marginRight: 5 }}
                  /> na listagem de protocolos.
                </span>
              </>
            </Visibility>

            <Visibility visible={hasCustomForm(PhasesProtocols.REGISTRO_EVENTOS_ADVERSOS)}>
              <>
                <img
                  width={60}
                  src={iconAlert}
                  alt=""
                  style={{ marginTop: 120, marginBottom: 20, alignSelf: 'center' }}
                />
                <span style={{ textAlign: 'center', lineHeight: 1.5 }}>
                  Para seguir com o atendimento deste protocolo é necessário registrar os eventos adversos dessa ocorrência. Para isso,
                </span>
                <span style={{ textAlign: 'center', paddingTop: 4 }}>
                  utilize o ícone <img
                    width={18}
                    src={iconOrderLost}
                    alt=""
                    style={{ marginLeft: 5, marginRight: 5 }}
                  /> na listagem de protocolos.
                </span>
              </>
            </Visibility>

            <Visibility visible={!hasCustomForm()}>
              <>
                <Visibility visible={setVisibleOrShowExpiredDate(form?.card?.fields)}>
                  <DateExpire
                    title="Data de vencimento da fase"
                    shouldExpireAt={form?.card?.currentLateness?.shouldBecomeLateAt}
                    expiredAt={form?.card?.currentLateness?.becameLateAt}
                    show
                  />
                </Visibility>

                <Column>
                  {(form.card.current_phase.fields as FieldsCurrentPhaseProps[]).map(
                    (item, index) => {
                      const ComponentType = components[item.type];
                      const typesMatched = [
                        "radio_vertical",
                        "radio_horizontal",
                        "checklist_horizontal",
                        "checklist_vertical",
                      ];

                      return showField(item) && (
                        typesMatched.indexOf(item.type) !== -1 ? (
                          <Column
                            key={index}
                            style={{ marginBottom: 20 }}
                          >
                            <p
                              className="mb-1"
                              style={{
                                color: "#293e52",
                                fontWeight: 600,
                              }}
                            >
                              {item.label.charAt(0).toUpperCase() +
                                item.label.slice(1) + `${item.required ? ' *' : ''}`}
                            </p>
                            <Validator
                              value={state[item.id]}
                              name={item.label}
                              required={item.required}
                            >
                              <ComponentType
                                {...item}
                                //disabled={isDisabledInputsCheckListAndRadio(item)}
                                disabled={true}
                                key={`${index}_input`}
                                value={state[item.id]}
                                options={item.options}
                                required={item.required}
                                onChange={(e: any) => {
                                  setState({
                                    ...state,
                                    [item.id]: e.target.value,
                                  });
                                  setLastChangedField({
                                    id: item.id,
                                    value: e.target.value,
                                  });
                                }}
                              />
                            </Validator>
                          </Column>
                        ) : (
                          <BaseField
                            key={index}
                            label={(item.id === "revis_o_do_texto_da_carta_de_corre_o"
                              || item.id === "revis_o_do_texto_da_carta_de_corre_o_1") &&
                              card?.ticketReason !== "CARTA DE CORREÇÃO" ? '' :
                              item.label.charAt(0).toUpperCase() +
                              item.label.slice(1) +
                              `${isFieldRequired(item) ? " *" : ""}`
                            }
                            description={
                              getInputDescriptionById(item.id) ||
                              item.description
                            }
                          >
                            {card?.ticketReason === "CARTA DE CORREÇÃO" &&
                              item.help &&
                              <img
                                src={imgToolTipRI}
                                data-tooltip-content={item.help}
                                data-tooltip-place={'top'}
                                className="RIToolTip"
                              />
                            }
                            <Validator
                              value={showValueOfValidator(item)}
                              name={item.label}
                              required={isFieldRequired(item)}
                              minLength={setMinLengthReviewLetter(item)}
                            >
                              <ComponentType
                                {...item}
                                key={`${index}_input`}
                                value={
                                  item.label === "Responsável pelo Atendimento" ?
                                    `${user!.username} - ${user!.fullName}`
                                    :
                                    item.label === "BU" ? setValueBUSelected()
                                      : state[item.id]
                                }
                                options={item.options}
                                onChange={(e: any) => {
                                  setState({
                                    ...state,
                                    [item.id]: e.target.value,
                                  });
                                }}
                                required={isFieldRequired(item)}
                                onBlur={(e: any) => {
                                  setLastChangedField({
                                    id: item.id,
                                    value: e.target.value,
                                  });
                                }}
                                //readOnly={mustInputBeReadOnly(item)}
                                //disabled={setMoveCardDisable(EnumDisableContext.Input)
                                //  || item.id === 'tipo_do_documento' && !requiredInputVigencyDate(item)}
                                disabled={true}
                                readOnly={true}
                              />
                            </Validator>
                            {item.help && <ReactTooltip variant="light" />}
                          </BaseField>
                        )
                      );
                    }
                  )}
                </Column>
              </>
            </Visibility>
          </Column>
          <Visibility visible={false}>
            <button
              disabled={blockMoveCardAwaitUpdateField || setMoveCardDisable(EnumDisableContext.Button)}
              className="move-to justify-center align-center cursor-pointer"
              form="pipefy_form"
            >
              <p className="font-bold">Mover para</p>
            </button>
          </Visibility>
        </Form>
        <Animated
          className="move-steps bg-white pp-scroll"
          show={moveCard}
          animationIn="slideInUp"
          animationInDelay="faster"
          animationOut="fadeOutDown"
          animationOutDelay="faster"
        >
          <Row className="move-header align-center justify-between">
            <p
              className="font-bold flex-1"
              style={{ borderRight: "1px solid rgba(59,91,253,.2)" }}
            >
              Fases
            </p>
            <Row
              className="align-center"
              onClick={() => setMoveCard((oldCard) => !oldCard)}
            >
              <span className="pp-ico-close cursor-pointer" />
            </Row>
          </Row>
          <Column className="move-body">
            {getPastPhases().map((phase: any, key: number) => (
              <Row
                key={key}
                onClick={() => moveCardTo(phase.id, phase.name)}
                className="item justify-between align-center"
              >
                <p>{phase.name}</p>
                <span className="pp-ico-bold-arrow-left cursor-pointer" />
              </Row>
            ))}
            {getPhases().map((phase: any, key: number) => (
              <Row
                key={key}
                onClick={() => moveCardTo(phase.id, phase.name)}
                className="item justify-between align-center"
              >
                <p>{phase.name}</p>
                <span className="pp-ico-bold-arrow-right cursor-pointer" />
              </Row>
            ))}
          </Column>
        </Animated>
      </Column>
    </Column>
  );
};

export default PhaseForm;